module.exports = __webpack_public_path__ + "applabcreateprojectwpcf448e2676e480e4b6e76d1f2a789375.png";